import type { FeaturesType } from '@/lib/features';
import { logger } from '@/lib/logger';

type logFPTISpinnerRenderedParams = { spinnerType: string };
const logFPTISpinnerRendered = ({
  spinnerType,
}: logFPTISpinnerRenderedParams): void => {
  logger.fpti('progressive_spinner_rendered', {
    event_name: 'checkout_post_review_spinner_shown',
    item_desc: spinnerType,
    product: 'checkout',
    state_name: 'post_review_spinner',
    transition_name: 'prepare_post_review_spinner',
  });
};

const logFPTISpinnerDuration = (
  clientFeatures: Partial<FeaturesType['config']>,
): void => {
  const progressiveSpinnerTreatment = !clientFeatures.isWps;
  if (!progressiveSpinnerTreatment) {
    return;
  }

  const spinnerMarks = window.performance?.getEntriesByName(
    'TransitionSpinnerRender',
  );
  if (!spinnerMarks || spinnerMarks.length === 0) {
    return;
  }

  const now = window.performance?.now();
  const markStartTime = spinnerMarks[0].startTime;
  const duration = now - markStartTime;

  logger.fpti('progressive_spinner_duration', {
    event_name: 'checkout_post_review_redirect_occurred',
    product: 'checkout',
    state_name: 'post_review_spinner',
    total_duration: duration,
    transition_name: 'prepare_post_review_spinner',
  });
};

export { logFPTISpinnerRendered, logFPTISpinnerDuration };
